import { splitRanges, unwrapElement } from ".";

interface Props {
  editor: any;
  lastRange: Range | null;
  data: string | null;
}

export const classificationHandler = ({ editor, lastRange, data }: Props) => {
  const selection = window.getSelection();
  if (!selection || !selection.rangeCount) return;
  if (selection && lastRange) {
    selection.removeAllRanges();
    selection.addRange(lastRange);
  }

  let range = selection.getRangeAt(0).cloneRange();
  if (selection.isCollapsed && data != null) {
    const block = editor.node.blockParent(selection.focusNode);
    if (block) {
      range = new Range();
      range.selectNodeContents(block);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }

  removeClassification(editor, selection);

  if (data != null) {
    range = selection.getRangeAt(0).cloneRange();
    for (const r of splitRanges(range)) {
      const c = document.createElement("span");
      c.setAttribute("data-ai-classification", data);
      r.surroundContents(c);
    }
  }
};

const removeClassification = (editor: any, selection: Selection) => {
  const blocks = editor.selection.blocks() as HTMLElement[];
  const aiItems: HTMLElement[] = [];
  editor.selection.save();

  blocks.forEach((block, i) => {
    if (block instanceof HTMLElement) {
      block.normalize();

      const _aiItems = block.querySelectorAll(
        "[data-ai-classification]",
      ) as any;
      aiItems.push(..._aiItems);
    }
  });

  aiItems.forEach((item) => {
    if (selection.containsNode(item, true)) {
      const attrs = item.getAttributeNames();
      if (attrs.length === 1 && attrs[0] === "data-ai-classification") {
        unwrapElement(item);
      } else item.removeAttribute("data-ai-classification");
    }
  });

  blocks.forEach((block) => {
    if (block instanceof HTMLElement) {
      block.normalize();
    }
  });

  editor.selection.restore();
};
